module.exports = __webpack_public_path__ + "static/img/92.d9056c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/92.png
// module id = Gjjq
// module chunks = 0